export default {
  'menu.exception.403': '403',
  'exception.result.403.description': '对不起，您没有访问该资源的权限',
  'exception.result.403.back': '返回',
};
